import React, { useCallback, useState } from 'react';
import styled, { css } from 'styled-components';
import { Formik, Form } from 'formik';
import { localize } from 'react-localize-redux';
import './Chat.css';
import AttachFile from '@material-ui/icons/AttachFile';
import { CSSTransitionGroup } from 'react-transition-group';
import CtaSecondary from 'components/ui/CtaSecondary'
import { colors } from 'helpers/ColorHelper';

const StyledForm = styled(Form)`
  padding: 0 1rem 0.5rem;
  position: relative;
  @media (max-width: 768px) {
    padding: ${props => props.isChatDrawer ? '0 1rem 0.5rem' : '0 1rem 2.5rem'}; ;
  }
`

const StyledTextarea = styled.textarea`
  padding: 1rem;
  width: 100%;
  resize: none;
  border: 1px solid ${colors.LIGHT_PERIWINKLE};
  border-radius: 0.5rem;
  padding-right: 116px;
`;

const StyledFileInputLabel = styled.label`
  position: absolute;
  display: flex;
  bottom: ${props => props.attachedFile ? '3.7rem' : '1.7rem'};
  right: 7rem;
  color: ${colors.ULTRAMARINE_BLUE}!important;
  cursor: pointer;
  ${props => !props.isChatDrawer && css`
    @media (max-width: 768px) {
      bottom: ${props => props.attachedFile ? '5.7rem' : '3.7rem'};
    }
  `}
`;

const StyledFileInput = styled.input`
  display: none;
`

const StyledSendButton = styled(CtaSecondary)`
  position: absolute;
  right: 1.5rem;
  bottom: ${props => props.attachedFile ? '4rem' : '2rem'};
  text-transform: capitalize;
  color: ${colors.ULTRAMARINE_BLUE};
  background-color: ${colors.LIGHT_BLUE_GREY};
  border: none;
  height: 2rem;
  line-height: 2rem;
  ${({ isChatDrawer }) => !isChatDrawer && css`
    @media (max-width: 768px) {
      bottom: ${props => props.attachedFile ? '6rem' : '4rem'}; ;
    }
  `}
`

const StyledAttachementP = styled.p`
  font-size: 0.875rem;
  color: ${colors.MEDIUM_GREY};
  text-overflow: ellipsis;
`

const mimeTypes =
'image/jpeg, image/png, image/jpg, application/pdf, application/excel, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document';

const ComposeMessage = localize()(({activeConversation, sendMessage, translate, isChatDrawer, markMessagesAsRead}) => {
  const [enterSubmitsForm] = useState(false)

  const handleSubmit = useCallback((values, {setValues}) => {
    const {text, file} = values
    if (text || file) {
      sendMessage(text.trim(), activeConversation.id, file)
      setValues({text: '', file: null})
    }
  }, [sendMessage, activeConversation]);

  return (
    <Formik
      initialValues={{
        text: '',
        file: null
      }}
      onSubmit={handleSubmit}
    >
      {({values, handleChange, setFieldValue, submitForm}) => (
        <>
          <StyledForm isChatDrawer={isChatDrawer}>
            <StyledTextarea
              name="text"
              rows="3"
              placeholder={translate('composeMessage').props.children}
              onChange={handleChange}
              value={values.text}
              onKeyDown={e => {
                if (enterSubmitsForm && e.key === 'Enter' && !e.shiftKey) {
                  e.preventDefault();
                  submitForm();
                }
              }}
            />
            <StyledFileInputLabel
              attachedFile={values.file}
              isChatDrawer={isChatDrawer}
            >
              <AttachFile />
              <StyledFileInput
                type="file"
                style={{ display: 'none', width: '0px' }}
                accept={mimeTypes}
                onChange={e => setFieldValue("file", e.currentTarget.files[0])}
              />
            </StyledFileInputLabel>
            <StyledSendButton
              attachedFile={values.file}
              isChatDrawer={isChatDrawer}
            >
              {translate("landlordPortal.messaging.send")}
            </StyledSendButton>
            <CSSTransitionGroup
              transitionName="seventeen_px"
              transitionEnterTimeout={500}
              transitionLeaveTimeout={500}
            >
              {values.file && (
                <StyledAttachementP>
                  {translate('messaging.sendingWithAttachment')}: {values.file.name}
                </StyledAttachementP>
              )}
            </CSSTransitionGroup>
          </StyledForm>
        </>
      )}
    </Formik>
  )
})

export default ComposeMessage